'use strict';

var formValidation = require('../components/formValidation');
var scrollAnimate = require('base/components/scrollAnimate');
var $contactForm = $('form.contactus-form');
var dataTransfer = new DataTransfer();
var fileSelector = $('#webformInputFile');
var switchSelector = $('input.switch-control');
var $userBusinessFields = $('.user-business-fields');
var conditionalParentField = $('.conditional-parent');
var conditionalChildField = $('.conditional-child');
var textAreaField = $('.input-textarea');
var base64FileArr = [];
var maxSize = 25 * 1048576;// 25MB in byte
var totalSize = 0;
var inputErrorMessage = $('.error-input-file');
var MAX_NUMBER_FILE = 5;
var SUCCESS_PROPERTIES = $contactForm.data('message-success') || "";
var FAIL_PROPERTIES = $contactForm.data('message-fail') || "";
var MISSING_PROPERTIES = $contactForm.data('message-missing') || "";
var debounce = require('lodash/debounce');
var debounceSumbitContactForm = debounce(handleSumbitContactForm, 1000);

var obj = {
    "product-information" : "dwfrm_contactUs_bikeAccessoryName, dwfrm_contactUs_productGroup",
    "availability" : "dwfrm_contactUs_bikeAccessoryName, dwfrm_contactUs_productGroup",
    "order-information" : "dwfrm_contactUs_orderNumber",
    "payment" : "dwfrm_contactUs_orderNumber",
    "shipment-delivery" : "dwfrm_contactUs_orderNumber",
    "return-refund" : "dwfrm_contactUs_orderNumber",
    "cancellation-refund" : "dwfrm_contactUs_orderNumber",
    "warranty-defects" : "dwfrm_contactUs_bikeAccessoryName, dwfrm_contactUs_serialNumber, dwfrm_contactUs_productGroup",
    "damage-transit" : "dwfrm_contactUs_orderNumber",
    "mainteinance" : "dwfrm_contactUs_bikeAccessoryName, dwfrm_contactUs_productGroup",
    "technical-support" : "dwfrm_contactUs_bikeAccessoryName, dwfrm_contactUs_serialNumber, dwfrm_contactUs_productGroup",
};

function textAreaAdjust(element) {
    element[0].style.height = "55px";
    element[0].style.height = (element[0].scrollHeight)+"px";
}

function convertToBase64(file) {
    return new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onload = function() {
        resolve({
          'Title': file.name,
          'PathOnClient': '/'+file.name,
          'VersionData': reader.result.split("base64,")[1]
        });
      };
      reader.onerror = function() {
        reject(new Error("Error when converting the file to base64"));
      };
      reader.readAsDataURL(file);
    });
}

function showErrorFile(type) {
    if(type) {
        switch (type) { 
            case 'size': 
                inputErrorMessage.text(inputErrorMessage.attr('data-size-message'))
                break;
            case 'length': 
                inputErrorMessage.text(inputErrorMessage.attr('data-length-message'))
                break;
            case 'size-all': 
                inputErrorMessage.text(inputErrorMessage.attr('data-sizeall-message'))
                break;
            default:
                //;
        }
        inputErrorMessage.show();
        fileSelector.val('');
    }
}

function createBase64(promises) {
    base64FileArr = [];
    Promise.all(promises).then(function(results) {
        base64FileArr = results;
    }).catch(function(error) {
        console.log(error);
    });
}

fileSelector.on('change', function() {
    var promises = [];
    if(dataTransfer.files.length <= MAX_NUMBER_FILE && this.files.length <= MAX_NUMBER_FILE ) {
        inputErrorMessage.hide();
        for(var i = 0; i < this.files.length; i++){
            var selectedfile = this.files[i];
            if(this.files.length > 0 && this.files.length <= MAX_NUMBER_FILE) {
                //render filename slot in html
                if (this.files[i].size < maxSize) {
                    inputErrorMessage.hide();
                    var fileBlock = $('<div/>', {class: 'webformFile__block'});
                    var fileName = $('<span/>', {class: 'webformFile__name', text: selectedfile.name});
                    fileBlock.append('<span class="webformFile__delete cta-attach cta-attach--remove"></span>').append(fileName);
                    $("#webformFile__list > #webformFile__names").append(fileBlock);
                } else {
                    showErrorFile('size');
                }
            } else {
                showErrorFile('length');
            }
        };
        for (let file of this.files) {
            dataTransfer.items.add(file);
        }
        this.files = dataTransfer.files;
        //remove added file
        $('span.webformFile__delete').click(function(){
            let name = $(this).next('span.webformFile__name').text();
            $(this).parent().remove();
            for(var i = 0; i < dataTransfer.items.length; i++){
                if(name === dataTransfer.items[i].getAsFile().name){
                    dataTransfer.items.remove(i);
                    continue;
                }
            }
            fileSelector[0].files = dataTransfer.files;
            //conversion to base64 files if removed some file
            promises = [];
            for (var i = 0; i < dataTransfer.files.length; i++) {
                if (dataTransfer.files[i].size > maxSize) {
                    showErrorFile('size');
                } else {
                    totalSize += dataTransfer.files[i].size;
                    promises.push(convertToBase64(dataTransfer.files[i]));
                }
            }
            if(totalSize > maxSize){
                showErrorFile('size-all');
            } else {
                $('.error-input-file').empty()
                createBase64(promises);
            }
        });

        //Conversion to base64 files
        for (var i = 0; i < dataTransfer.files.length; i++) {
            if (dataTransfer.files[i].size > maxSize) {
                showErrorFile('size');
              } else {
                totalSize += dataTransfer.files[i].size;
                promises.push(convertToBase64(dataTransfer.files[i]));
            }
        }
        if(totalSize > maxSize){
            showErrorFile('size');
        } else {
            $('.error-input-file').empty()
            createBase64(promises);
        }
    } else {
        showErrorFile('length');
    }
});

switchSelector.on('change', function() {
    if (this.checked) {
        $userBusinessFields.slideDown();
    } else {
        $userBusinessFields.slideUp();
    }
    fileSelector[0].files = dataTransfer.files;
});

conditionalParentField.on('change', function() {
    var thisVal = $(this).find('input, select option:selected').attr('optionid');
    if(thisVal && obj) {
        conditionalChildField.hide();
        if(obj[thisVal]) {
            var targetElement = obj[thisVal].split(',');
            $.each(targetElement, function( index, value ) {
                $('.conditional-child[data-conditional-child='+value.trim()+']').show();
            });
        }
    }
});

textAreaField.on('keyup', function(){
    textAreaAdjust($(this));
});

$contactForm.on('submit', function (e) {
    e.preventDefault();
    debounceSumbitContactForm($(this));
});

function handleSumbitContactForm($form) {
    var url = $form.attr('action');
    var redirectUrl = $form.find('.button-submit button').data('urlRedirect');
    var addAttachmentUrl = $form.data('addAttachmentUrl');
    var $formSelector = $form;
    var formParams = $form.find(":input:not(:hidden), :input.internationalPhoneNumber[type=hidden], select:not(:hidden), input[name=csrf_token]").serialize();
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'POST',
        data: formParams,
        processData: false,
        success: function (data) {
            if (data.success && data.id) {
                if (base64FileArr) {
                    var ajaxCallsArray = [];
                    for (var file of base64FileArr) {
                        var formData = new FormData();
                        file.caseID = data.id;
                        formData.append('caseID', file.caseID);
                        formData.append('VersionData', file.VersionData);
                        formData.append('Title', file.Title);
                        formData.append('PathOnClient', file.PathOnClient);
                        ajaxCallsArray.push($.ajax({
                            url: addAttachmentUrl,
                            type: 'POST',
                            data: formData,
                            processData: false,
                            contentType: false
                        }));
                    }

                    Promise.all(ajaxCallsArray).then(() => {
                        //toastr.success(SUCCESS_PROPERTIES);
                        if(redirectUrl) {
                            window.location.href = redirectUrl+'?toastr=success';
                        }
                    }).catch(() => {
                        toastr.error(SUCCESS_FAIL);
                    }).finally(() => {
                        $.spinner().stop();
                    });
                } else {
                    //toastr.success(SUCCESS_PROPERTIES);
                    $.spinner().stop();
                    if(redirectUrl) {
                        window.location.href = redirectUrl+'?toastr=success';
                    }
                }

                // reset form fields
                $form[0].reset();
                $form.find('.form-control.is-invalid').removeClass('is-invalid');
                // reset field file input
                dataTransfer.clearData();

                //clear attachments
                fileSelector.val('');
                $('#webformFile__box').empty()
                base64FileArr = [];
            } else {
                formValidation($formSelector, data);
                scrollAnimate($('form .is-invalid:first').closest('.card'));
                if(!data.success) {
                    toastr.error(MISSING_PROPERTIES);
                }
                $.spinner().stop();
            }
        },
        error: function (err) {
            console.log(err);
            toastr.error(FAIL_PROPERTIES);
            $.spinner().stop();
        }
    });
}